// Copyright 1999-2020. Plesk International GmbH. All rights reserved.

/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
/**
 * `Tab` is an individual element of the [Tabs](#!/Tabs) component.
 *
 * Each `Tab` can display an icon near the tab name for easier identification.
 * It can also display a [Label](#!/Label) next to the tab name for showing additional information about its content.
 * You can make `Tabs` closeable, for example, if you are using them for opening and displaying files.
 * @since 0.0.35
 */

const Tab = ({
  children
}) => /*#__PURE__*/React.createElement("div", null, children);

Tab.propTypes = {
  /**
   * Tab title
   * @since 0.0.35
   */
  title: PropTypes.node.isRequired,

  /**
   * Label in tab title
   * @since 0.0.42
   */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),

  /**
   * Name of icon or Icon component for tab
   * @since 0.0.42
   */
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.element]),

  /**
   * Activate callback.
   * @since 0.0.43
   */
  onActivate: PropTypes.func,

  /**
   * Close callback
   * @since 0.0.58
   */
  onClose: PropTypes.func,

  /**
   * Component to render as the root element.
   * @since 2.5.1
   */
  component: PropTypes.elementType,

  /**
   * Tab content
   * @since 0.0.47
   */
  children: PropTypes.node
};
Tab.defaultProps = {
  label: undefined,
  icon: undefined,
  onActivate: undefined,
  onClose: undefined,
  children: undefined,
  component: undefined
};
export default Tab;